import { Link } from "react-router-dom";
import type { Article } from "@/mocks/chigua";
import { kindBadge, toneOf, formatHeat } from "@/lib/chiguaData";

export default function StoryCard({ item }: { item: Article }) {
  const t = toneOf(item.channel);
  return (
    <article className="group border-b border-background-200 pb-5">
      <div className="mb-2 flex items-center gap-2 text-xs text-foreground-500">
        <span className={`inline-flex items-center gap-1 rounded px-1.5 py-0.5 font-medium ${t.softBg} ${t.text}`}>
          <i className={`h-1.5 w-1.5 rounded-full ${t.dot}`} aria-hidden="true" />
          {item.kind}
        </span>
        <time>{item.date}</time>
        <span className="hidden items-center gap-1 sm:inline-flex">
          <i className="ri-time-line" aria-hidden="true" />
          {item.minutes} 分钟阅读
        </span>
      </div>
      <Link to={`/story/${item.slug}`}>
        <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition group-hover:text-primary-700 md:text-[17px]">
          {item.title}
        </h3>
      </Link>
      <p className="mt-2 hidden text-sm leading-6 text-foreground-600 md:line-clamp-2">{item.excerpt}</p>
      <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
        <span className="inline-flex items-center gap-1">
          <i className="ri-pencil-line text-foreground-400" aria-hidden="true" />
          {item.author}
        </span>
        <span className="inline-flex items-center gap-1">
          <i className="ri-fire-line text-accent-500" aria-hidden="true" />
          {formatHeat(item.heat)} 热度
        </span>
        <span className="ml-auto hidden items-center gap-1 text-foreground-400 transition group-hover:text-primary-600 sm:inline-flex">
          进入全文
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </span>
      </div>
    </article>
  );
}